export default __webpack_public_path__ + "static/media/tik.dcda332e.svg";